import { useState, useEffect } from 'react';
import { blue, green, yellow } from 'theme/theme.constant';
import './TripReport.scss';
import { connect, useDispatch, useSelector } from 'react-redux';
import { EV_ENDPOINT_FETCH_TRIP_REPORT, GET_VEHICLE_BY_GROUP } from 'services/APIConstants';
import moment from 'moment';
import { apiPost } from 'services/api.service';
import { ReactComponent as DownloadIcon } from 'assets/icons/download.svg';
import { ReactComponent as ChargeIcon } from 'assets/icons/chargeevent.svg';
import { ReactComponent as DischargeIcon } from 'assets/icons/dischargeevent.svg';
import { ReactComponent as CalendarIcon } from 'assets/icons/calendar.svg';
import MultiSelect from 'app/shared/MultiSelect';
import DatePicker from 'app/shared/DateTimePicker';
import SearchBox from 'app/shared/SearchBox';
import { download_csv, getHourMin, updateSessionMeta } from 'utils/HelperFunctions';
// import BoltLoader from 'app/shared/BoltLoader';
import {
	UPDATE_TRIP_REPORT_DATA,
	TRIP_REPORT_SELECTED_GROUP_TREE,
	SHOWING_DATA_FOR,
} from 'app/config/Redux/global.action';
import EmptyState from 'app/shared/EmptyState';
import Tooltip from 'app/shared/Tooltip';
import { Toaster } from 'app/shared/Toast';
// import RadialProgress from 'app/shared/RadialProgress';
import GroupTree from '../../../../shared/GroupTree/GroupTree';
import { UPDATE_VEHICLE_LIST } from 'app/config/Redux/global.action';
import {
	updateTripReportData,
	setTripReportGroupTree,
	setShowingDataFor,
	updateVehicleList,
} from 'app/config/Redux/global.reducer';
import { useLocation } from 'react-router';

const colorArray = [
	'#16b87d',
	'#bc1b45',
	'#871795',
	'#c8551b',
	'#c5da1a',
	'#1a8ecf',
	'#984620',
	'#a0b831',
	'#173ec1',
	'#626262',
	'#0f5c24',
	'#dd867c',
	'#46b8d3',
	'#dbd780',
];

//eslint-disable-next-line
const eventType = {
	0: '#5ce3b5',
	1: '#fdcc55',
	'-1': '#e9445f',
};

//string

function TripReport() {
	const dispatch = useDispatch();
	const location = useLocation();

	// Redux selectors
	const vehicleList = useSelector((state) => state.vehicleList);
	const tripReport = useSelector((state) => state.tripReport);
	const myGroup = useSelector((state) => state.myGroup);
	const fixedVehicleList = useSelector((state) => state.fixedVehicleList);
	const tripReportGroupTree = useSelector((state) => state.tripReportGroupTree);
	const showingDataFor = useSelector((state) => state.showingDataFor);

	// Local state (keeping your existing state declarations)
	const [reportBucketOpen, setReportBucketOpen] = useState([]);
	const [dailyBucketOpened, setDailyBucketOpened] = useState([]);
	const [reportType, setReportType] = useState(1);
	//eslint-disable-next-line
	const [isLoading, setLoading] = useState(false);
	const [filteredReport, setFilteredReport] = useState(tripReport ? tripReport.history : []);
	const [startTime, setStartTime] = useState(moment().subtract(2, 'day').startOf('day').valueOf());
	const [endTime, setEndTime] = useState(moment().subtract(1, 'day').endOf('day').valueOf());
	const [selectedVehicle, setSelectedVehicle] = useState([]);
	const [copiedVehicle, setCopiedVehicle] = useState('');
	const [isError, setIsError] = useState(false);
	const [pageNo, setPageNo] = useState(1);
	const [groups, setGroups] = useState([]);
	const [selectedGroup, setSelectedGroup] = useState(null);
	const [loadingVehicle, setLoadingVehicle] = useState(false);
	const [dataForGroup, setDataForGroup] = useState([]);
	// const [dataForVehicle, setDataForVehicle] = useState('');
	const [openDownload, setOpenDownload] = useState(false);

	useEffect(() => {
		// console.log("tripreport useffect",tripReport,vehicleList)
		if (!vehicleList.length) setLoading(true);
		const initializeComponent = async () => {
			await initPreserveState();
			window.group = [];

			if (showingDataFor?.tripreport) {
				setDataForGroup(showingDataFor.tripreport);
			} else if (window.userGroups) {
				setDataForGroup([window.userGroups[0]]);
			}
		};

		initializeComponent();
	}, []);

	useEffect(() => {
		if (tripReportGroupTree.length === 0 && myGroup) {
			let group = { ...myGroup };

			if (!group.path) {
				if (Object.keys(group).length > 0) {
					group = { ...group.children[0] };
				} else {
					group = {
						path: '/0/0/',
						ppath: '/0/0/',
					};
				}
			}

			window.group = { ...group };

			if (Object.keys(myGroup).length > 1) {
				setGroups({ ...group });
				navigate({ ...group });
			}
		} else {
			window.group = { ...tripReportGroupTree[0] };
			setGroups([...tripReportGroupTree]);
			navigate({ ...tripReportGroupTree[tripReportGroupTree.length - 1] });
		}
		console.log("my group",myGroup)
	}, [myGroup]);

	// Move initPreserveState inside the component
	const initPreserveState = async () => {
		const pageKey = location.pathname.replaceAll('/', '');
		const metaData = JSON.parse(sessionStorage.getItem(pageKey));
		// console.log("inside init preserve state")

		if (tripReport === null && metaData === null) {
			const initialVehicles = vehicleList.slice(0, 1000).map((vehicle) => vehicle.vehicleid);

			setSelectedVehicle(initialVehicles);
			updatePreserveState('selectedVehicle', initialVehicles);
			// console.log('calling fetchTripReport 1', initialVehicles, vehicleList);
			await fetchTripReport(startTime, endTime, initialVehicles);
			return;
		}

		if (metaData) {
			if (metaData.starttime) {
				setStartTime(parseInt(metaData.starttime));
			}
			if (metaData.endtime) {
				setEndTime(parseInt(metaData.endtime));
			}
			if (metaData.selectedVehicle) {
				setSelectedVehicle([...selectedVehicle, ...metaData.selectedVehicle]);
				if (tripReport === null) {
					// console.log('calling fetchTripReport 2');
					await fetchTripReport(
						metaData.starttime ? parseInt(metaData.starttime) : startTime,
						metaData.endtime ? parseInt(metaData.endtime) : endTime,
						metaData.selectedVehicle
					);
				}
			}

			if (metaData.reportBucketOpen) {
				setReportBucketOpen((prev) => [...prev, ...metaData.reportBucketOpen]);
			}
			if (metaData.dailyBucketOpen) {
				setDailyBucketOpened((prev) => [...prev, ...metaData.dailyBucketOpen]);
			}
			if (metaData.reportType) {
				setReportType(parseInt(metaData.reportType));
			}
			if (metaData.scrollElem) {
				const elem = document.getElementById('reportBox' + metaData.scrollElem);
				if (elem) elem.scrollIntoView();
			}
		}
	};

	const updatePreserveState = (key, value) => {
		let pageKey = location.pathname.replaceAll('/', '');
		updateSessionMeta(key, value, pageKey);
	};

	const handleViewState = () => {
		const urlParams = new URLSearchParams(window.location.search);
		if (urlParams.get('reportBucketOpen')) {
			setReportBucketOpen([...reportBucketOpen, ...JSON.parse(urlParams.get('reportBucketOpen'))]);
		}
		if (urlParams.get('dailyBucketOpen')) {
			setDailyBucketOpened([...dailyBucketOpened, ...JSON.parse(urlParams.get('dailyBucketOpen'))]);
		}
		if (urlParams.get('reportType')) {
			setReportType(parseInt(urlParams.get('reportType')));
		}
		if (urlParams.get('scrollElem')) {
			let elem = document.getElementById('reportBox' + urlParams.get('scrollElem'));
			if (elem) elem.scrollIntoView();
		}
	};

	const getVehicleNo = (vehicleId) => {
		let vehicles = fixedVehicleList;
		let result = vehicles.find((vehicle) => vehicle.vehicleid === vehicleId);
		return result ? result.vehicleno : '';
	};
	const processTripReport = (data) => {
		let reportData = JSON.parse(JSON.stringify(data.history));

		for (let idx in reportData) {
			reportData[idx].vehicleno = getVehicleNo(parseInt(reportData[idx].vehicleid));
			for (let jdx in reportData[idx].data.data) {
				for (let kdx in reportData[idx].data.data[jdx].values) {
					reportData[idx].data.data[jdx].values[kdx].starttime = moment(
						reportData[idx].data.data[jdx].values[kdx].starttime
					).format('DD MMM YYYY h:mm A');
					reportData[idx].data.data[jdx].values[kdx].endtime = moment(
						reportData[idx].data.data[jdx].values[kdx].endtime
					).format('DD MMM YYYY h:mm A');
					if (reportData[idx].data.data[jdx].values[kdx].state === 'c') {
						reportData[idx].data.data[jdx].values[kdx].chargeduration = getHourMin(
							reportData[idx].data.data[jdx].values[kdx].chargeduration
						);
					} else {
						reportData[idx].data.data[jdx].values[kdx].dischargeduration = getHourMin(
							reportData[idx].data.data[jdx].values[kdx].dischargeduration
						);
					}
				}
			}
		}
		data.history = reportData;
		dispatch(updateTripReportData(data));
		setFilteredReport(data.history);
		setLoading(false);
		handleViewState();
	};

	const isTimerangeOk = (start, end) => {
		let startTime = moment(start);
		let endTime = moment(end);
		let diff = endTime.diff(startTime, 'days');
		if (diff < 0 || diff > 30) {
			return false;
		} else {
			return true;
		}
	};

	const fetchTripReport = async (
		starttime = startTime,
		endtime = moment(endTime).endOf('day').valueOf(),
		vehicles = selectedVehicle
	) => {
		// console.log('Fetching,>>>>>>>>>>>', vehicles);
		setIsError(false);
		if (vehicles.length === 0) {
			Toaster.error({
				title: 'No Vehicle Selected',
				message: 'Select at least 1 vehicle to get report data',
			});
			return;
		}

		if (!isTimerangeOk(startTime, endTime)) {
			Toaster.error({
				title: 'Invalid Date Selection',
				message: 'Max date range is 30 days please check your date range',
			});
			return;
		}

		setLoading(true);

		try {
			const response = await apiPost(EV_ENDPOINT_FETCH_TRIP_REPORT, {
				starttime,
				endtime,
				vehicleid: vehicles,
			});

			if (response.status === 'CRASHED') {
				setIsError(true);
			} else {
				const processedData = processTripReport(response.data);

				dispatch(updateTripReportData(processedData));

				if (selectedGroup) {
					setDataForGroup(groups);
					if (showingDataFor) {
						dispatch(
							setShowingDataFor({
								...showingDataFor,
								tripreport: groups,
							})
						);
					}
				}
			}
		} catch (error) {
			setIsError(true);
			Toaster.error({
				title: 'Error',
				message: 'Failed to fetch trip report',
			});
		} finally {
			setLoading(false);
		}
	};

	const statsColor = [green[300], '#F2B165', yellow[300], '#930173', blue[300], '#00499F'];

	const getTripData = (data) => {
		let finalArray = [];
		for (let idx in data) {
			finalArray.push(...data[idx].values);
		}
		return finalArray;
	};

	const handleReportBucket = (vehicleId) => {
		let data = reportBucketOpen;
		if (data.includes(vehicleId)) {
			setReportBucketOpen(data.filter((vehicle) => vehicle !== vehicleId));
			updatePreserveState(
				'reportBucketOpen',
				data.filter((vehicle) => vehicle !== vehicleId)
			);
		} else {
			setReportBucketOpen([...data, vehicleId]);
			updatePreserveState('reportBucketOpen', [...data, vehicleId]);
		}
		updatePreserveState('scrollElem', vehicleId);
	};
	const handleDailyBucket = (date) => {
		let data = dailyBucketOpened;
		if (data.includes(date)) {
			setDailyBucketOpened(data.filter((item) => item !== date));
			updatePreserveState(
				'dailyBucketOpen',
				data.filter((item) => item !== date)
			);
		} else {
			setDailyBucketOpened([...data, date]);
			updatePreserveState('dailyBucketOpen', [...data, date]);
		}
	};
	const searchTripReport = (key) => {
		let processData = tripReport.history;
		let filterReport = [];
		if (key.length >= 2) {
			for (let idx in processData) {
				if (
					processData[idx].vehicleid.toString().includes(key) ||
					processData[idx].vehicleno.includes(key.toUpperCase()) ||
					(processData[idx].model && processData[idx].model.includes(key))
				) {
					filterReport.push(processData[idx]);
				}
			}
			setFilteredReport(filterReport);
		} else {
			setFilteredReport(processData);
		}
	};
	const renderDaily = (data, vehicleId) => {
		let dailyReports = [];
		for (let idx in data) {
			dailyReports.push(
				<div className="ReportBoxContainer" key={idx}>
					<div className="ReportBox" onClick={() => handleDailyBucket(data[idx].date + vehicleId)}>
						<div className="BoxMeta">
							<div className="BoxNos-round">{parseInt(idx) + 1}</div>
							<div className="Date">
								<CalendarIcon />
								<span>{moment(parseInt(data[idx].date)).format('DD MMMM YYYY')}</span>
							</div>
						</div>
						<div className="BoxStats">{renderSummary(data[idx].stats)}</div>
					</div>
					{dailyBucketOpened.includes(data[idx].date + vehicleId) ? (
						<div className="TripContainer">{renderTrips(data[idx].values)}</div>
					) : null}
				</div>
			);
		}
		return dailyReports;
	};

	const renderTrips = (data) => {
		let trips = [];
		let heads = tripReport.meta.trip;
		for (let idx in data) {
			trips.push(
				<div className="TripReport" key={idx}>
					<div className="TripNos">{parseInt(idx) + 1}</div>
					<div className="TripDetails">
						<div className="TripTypeIcon">
							{data[idx].state === 'c' ? <ChargeIcon /> : <DischargeIcon />}
						</div>
						<div className="TripStats">
							<div className="StatsCol">
								<div className="Stats">
									<div className="ColorBox" style={{ backgroundColor: colorArray[0] }}></div>
									<div className="Detail">
										<span>{heads.starttime.heading}</span>
										<span>{data[idx].starttime}</span>
									</div>
								</div>
								<div className="Stats">
									<div className="ColorBox" style={{ backgroundColor: colorArray[1] }}></div>
									<div className="Detail">
										<span>{heads.endtime.heading}</span>
										<span>{data[idx].endtime}</span>
									</div>
								</div>
							</div>

							{/*  next column */}
							<div className="StatsCol">
								<div className="Stats">
									<div className="ColorBox" style={{ backgroundColor: colorArray[2] }}></div>
									<div className="Detail">
										<span>{heads.startvolt.heading}</span>
										<span>
											{data[idx].startvolt.toString().includes('-')
												? 'NA'
												: data[idx].startvolt + ' ' + heads.startvolt.unit}
										</span>
									</div>
								</div>
								<div className="Stats">
									<div className="ColorBox" style={{ backgroundColor: colorArray[3] }}></div>
									<div className="Detail">
										<span>{heads.endvolt.heading} </span>
										<span>
											{data[idx].endvolt.toString().includes('-')
												? 'NA'
												: data[idx].endvolt + ' ' + heads.startvolt.unit}
										</span>
									</div>
								</div>
							</div>

							{/*  next column */}
							<div className="StatsCol">
								<div className="Stats">
									<div className="ColorBox" style={{ backgroundColor: colorArray[1] }}></div>
									<div className="Detail">
										<span>{heads.startsoc.heading}</span>
										<span>
											{data[idx].startsoc} {heads.startsoc.unit}
										</span>
									</div>
								</div>
								<div className="Stats">
									<div className="ColorBox" style={{ backgroundColor: colorArray[5] }}></div>
									<div className="Detail">
										<span>{heads.endsoc.heading} </span>
										<span>
											{data[idx].endsoc} {heads.endsoc.unit}
										</span>
									</div>
								</div>
							</div>

							{/*  next column */}
							{data[idx].state === 'c' ? (
								<div className="StatsCol">
									<div className="Stats">
										<div className="ColorBox" style={{ backgroundColor: colorArray[6] }}></div>
										<div className="Detail">
											<span>SoC Charged</span>
											<span>
												{data[idx].soccharged.toString().includes('-')
													? 'NA'
													: data[idx].soccharged + ' %'}
											</span>
										</div>
									</div>
									<div className="Stats">
										<div className="ColorBox" style={{ backgroundColor: colorArray[7] }}></div>
										<div className="Detail">
											<span>Charge Duration </span>
											<span>{data[idx].chargeduration}</span>
										</div>
									</div>
								</div>
							) : null}

							{/*  next column */}
							{data[idx].state === 'd' ? (
								<>
									<div className="StatsCol">
										<div className="Stats">
											<div className="ColorBox" style={{ backgroundColor: colorArray[6] }}></div>
											<div className="Detail">
												<span>{heads.distance.heading}</span>
												<span>
													{data[idx].distance} {heads.distance.unit}
												</span>
											</div>
										</div>
										<div className="Stats">
											<div className="ColorBox" style={{ backgroundColor: colorArray[7] }}></div>
											<div className="Detail">
												<span>{heads.dischargeduration.heading} </span>

												<span>{data[idx].dischargeduration} </span>
											</div>
										</div>
									</div>

									<div className="StatsCol">
										<div className="Stats">
											<div className="ColorBox" style={{ backgroundColor: colorArray[8] }}></div>
											<div className="Detail">
												<span>{heads.socconsumed.heading}</span>
												<span>
													{data[idx].socconsumed.toString().includes('-')
														? 'NA'
														: data[idx].socconsumed + ' ' + heads.socconsumed.unit}
												</span>
											</div>
										</div>
										<div className="Stats">
											<div className="ColorBox" style={{ backgroundColor: colorArray[9] }}></div>
											<div className="Detail">
												<span>{heads.mileage.heading} </span>
												<span>
													{data[idx].mileage
														? data[idx].mileage.toString().includes('-')
															? 'NA'
															: data[idx].mileage + ' ' + heads.mileage.unit
														: 'NA'}
												</span>
											</div>
										</div>
									</div>
								</>
							) : null}
							{data[idx].state === 'c' && data[idx].eventtype !== 0 ? (
								<div className="StatsCol">
									<div className="Stats">
										<div className="ColorBox" style={{ backgroundColor: colorArray[8] }}></div>
										<div className="Detail">
											<span>Swap </span>
											<span
												style={{
													color: data[idx].eventtype > 0 ? '#52bb97' : '#eb5971',
													fontWeight: 600,
												}}
											>
												{data[idx].eventtype > 0 ? 'POSITIVE' : 'NEGATIVE'}
											</span>
										</div>
									</div>
								</div>
							) : null}
						</div>
					</div>
				</div>
			);
		}
		return trips;
	};
	const renderSummary = (data) => {
		let summary = [];
		let header = Object.entries(tripReport.meta.summary);
		for (let idx in header) {
			summary.push(
				<div key={idx} className="Stats">
					<div className="StatsColor" style={{ background: statsColor[idx] }}></div>
					<div className="StatsData">
						<span>{header[idx][1].heading}</span>
						<span>
							{data[header[idx][0]] != null ? data[header[idx][0]] : 'NA'}{' '}
							{data[header[idx][0]] != null
								? header[idx][1].unit
									? ' ' + header[idx][1].unit
									: ''
								: ''}
						</span>
					</div>
				</div>
			);
		}
		return summary;
	};

	const copyVehicleNo = (containerid, e) => {
		e.stopPropagation();
		let r = document.createRange();
		r.selectNode(document.getElementById(containerid));
		window.getSelection().removeAllRanges();
		window.getSelection().addRange(r);
		document.execCommand('copy');
		window.getSelection().removeAllRanges();
		setCopiedVehicle(containerid);
	};
	const renderLayout = () => {
		let reportbox = [];
		let data = filteredReport;
		for (let idx in data) {
			reportbox.push(
				<div key={idx} className="ReportBoxContainer">
					<div
						id={'reportBox' + data[idx].vehicleid}
						className="ReportBox"
						style={{
							opacity:
								data[idx].data.stats.totalchargingevents === 0 &&
								data[idx].data.stats.totaldischargingevents === 0
									? 0.4
									: 1,
							pointerEvents:
								data[idx].data.stats.totalchargingevents === 0 &&
								data[idx].data.stats.totaldischargingevents === 0
									? 'none'
									: '',
						}}
						onClick={() => handleReportBucket(data[idx].vehicleid)}
					>
						<div className="BoxMeta">
							<div className="BoxNos">{parseInt(idx) + 1}</div>
							<div className="VehicleData">
								<ul>
									<Tooltip
										text={
											copiedVehicle === 'vehicle' + idx ? (
												<>
													Copied <i className="fas fa-check-circle"></i>
												</>
											) : (
												'Click to copy vehicle no'
											)
										}
									>
										<li
											id={'vehicle' + idx}
											onClick={(e) => copyVehicleNo('vehicle' + idx, e)}
											className="firstItem"
										>
											{data[idx].vehicleno}
										</li>
									</Tooltip>
									<li className="secondItem">{data[idx].model}</li>
								</ul>
							</div>
						</div>
						<div className="BoxStats">{renderSummary(data[idx].data.stats)}</div>
					</div>
					{reportBucketOpen.includes(data[idx].vehicleid) ? (
						<div className={reportType === 0 ? 'TripContainer' : 'ReportBox-TripDaily'}>
							{reportType === 0
								? renderTrips(getTripData(data[idx].data.data))
								: renderDaily(data[idx].data.data, data[idx].vehicleid)}
						</div>
					) : null}
				</div>
			);
		}
		return reportbox;
	};

	const downloadSummary = () => {
		let str = '';
		let heads = [
			{
				hdg: 'Charging events',
				key: 'totalchargingevents',
			},
			{
				hdg: 'Trips',
				key: 'totaldischargingevents',
			},
			{
				hdg: 'Distance (km)',
				key: 'totaldistance',
			},
			{
				hdg: 'SoC consumed (%)',
				key: 'totsocconsumed',
			},
			{
				hdg: 'SoC Charged (%)',
				key: 'totsoccharged',
			},
			{
				hdg: 'Range (km)',
				key: 'mileage',
			},
		];
		let headline = 'Vehicle No,Model';
		for (var i = 0; i < heads.length; i++) {
			if (headline !== '') headline += ',';
			headline += heads[i]['hdg'];
		}
		str += headline + '\r\n';
		let tripData = filteredReport;

		for (let idx in tripData) {
			let line = '';
			// str += line + '\r\n';
			line = '';
			for (let kdx in heads) {
				if (parseInt(kdx, 10) === 0) {
					line = tripData[idx].vehicleno + ',' + tripData[idx].model;
				}
				if (line !== '') line += ',';
				line += tripData[idx].data.stats[heads[kdx].key] || 'NA';
			}

			str += line + '\r\n';
			line = '';
		}
		download_csv(
			str,
			`EV_TRIP_SUMMARY_REPORT_from-${moment(startTime).format('DD_MM_YYYY')}:to-${moment(
				endTime
			).format('DD_MM_YYYY')}-[${pageNo === 1 ? 0 : (pageNo - 1) * 1000}- ${pageNo * 1000}].csv`,
			() => {
				setOpenDownload(false);
			}
		);
	};
	const JSONToCSV = () => {
		let str = '';
		let heads = [
			{
				hdg: 'Event',
				key: 'state',
				type: 'event',
			},
			{
				hdg: 'Trip/Charge Start',
				key: 'starttime',
				type: 'date',
			},
			{
				hdg: 'Trip/Charge End',
				key: 'endtime',
				type: 'date',
			},
			{
				hdg: 'Start Voltage (V)',
				key: 'startvolt',
				type: 'none',
			},
			{
				hdg: 'End Voltage (V)',
				key: 'endvolt',
				type: 'none',
			},
			{
				hdg: 'Start SOC (%)',
				key: 'startsoc',
				type: 'none',
			},
			{
				hdg: 'End SOC (%)',
				key: 'endsoc',
				type: 'none',
			},

			{
				hdg: 'Total Distance (km)',
				key: 'distance',
				type: 'none',
			},
			{
				hdg: 'Trip Duration',
				key: 'dischargeduration',
				type: 'duration',
			},
			{
				hdg: 'SOC Charged (%)',
				key: 'soccharged',
				type: 'none',
			},
			{
				hdg: 'Charge Duration',
				key: 'chargeduration',
				type: 'duration',
			},
			{
				hdg: 'SOC Consumed (%)',
				key: 'socconsumed',
				type: 'none',
			},
			{
				hdg: 'Battery Swap',
				key: 'eventtype',
				type: 'none',
			},
		];

		let headline = 'Vehicle No,Model';
		for (var i = 0; i < heads.length; i++) {
			if (headline !== '') headline += ',';
			headline += heads[i]['hdg'];
		}
		str += headline + '\r\n';
		let tripData = filteredReport;
		for (let idx in tripData) {
			let line = '';
			str += line + '\r\n';
			line = '';
			for (let jdx in tripData[idx].data.data) {
				for (let hdx in tripData[idx].data.data[jdx].values) {
					for (let kdx in heads) {
						//eslint-disable-next-line
						if (kdx == 0) {
							line = tripData[idx].vehicleno + ',' + tripData[idx].model;
						}
						if (line !== '') line += ',';
						if (heads[kdx].key === 'eventtype') {
							line +=
								tripData[idx].data.data[jdx].values[hdx][heads[kdx].key] === -1
									? 'NEGATIVE'
									: tripData[idx].data.data[jdx].values[hdx][heads[kdx].key] === 1
									? 'POSITIVE'
									: 'NA';
						} else if (heads[kdx].key === 'state') {
							line +=
								tripData[idx].data.data[jdx].values[hdx][heads[kdx].key] === 'd'
									? 'Trip'
									: 'Charging';
						} else {
							line +=
								tripData[idx].data.data[jdx].values[hdx][heads[kdx].key] < 0
									? 'NA'
									: tripData[idx].data.data[jdx].values[hdx][heads[kdx].key] || 'NA';
						}
					}
					str += line + '\r\n';
					line = '';
				}
			}
		}
		download_csv(
			str,
			`EV_TRIP_REPORT_from-${moment(startTime).format('DD_MM_YYYY')}:to-${moment(endTime).format(
				'DD_MM_YYYY'
			)}-[${pageNo === 1 ? 0 : (pageNo - 1) * 1000}- ${pageNo * 1000}].csv`,
			() => {
				setOpenDownload(false);
			}
		);
	};

	const loadVehicle = async (groupid) => {
		try {
			setLoadingVehicle(true);
			const vehicles = await apiPost(GET_VEHICLE_BY_GROUP, { groupid });
			dispatch(updateVehicleList(vehicles.data));

			if (vehicles?.data) {
				let selected = vehicles.data.slice(0, 1000).map((vehicle) => vehicle.vehicleid);
				setSelectedVehicle(selected);
				let endtime = moment(endTime).endOf('day').valueOf();
				const pageKey = location.pathname.replaceAll('/', '');
				const metaData = JSON.parse(sessionStorage.getItem(pageKey));

				if (tripReport === null && metaData && !metaData.selectedVehicle.length) {
					// console.log("calling fetchTripReport from load vehicles",filteredReport)
					fetchTripReport(startTime, endtime, selected);
				}
			}
			return vehicles.data;
		} catch (error) {
			Toaster.error({
				title: 'Error',
				message: 'Failed to load vehicles',
			});
		} finally {
			setLoadingVehicle(false);
			setLoading(false)
		}
	};

	// const navigate = async (group) => {
	// 	const nav = [];
	// 	const currentNode = { ...window.group };
	// 	nav.push(currentNode);
	// 	console.log("nav",nav)

	// 	// ... your navigation logic

	// 	setGroups([...nav]);
	// 	if (nav.length > 1) {
	// 		dispatch(setTripReportGroupTree([...nav]));
	// 	} else if (myGroup?.children) {
	// 		dispatch(setTripReportGroupTree([{ ...myGroup.children[0] }]));
	// 	}

	// 	setSelectedGroup({ ...group });
	// 	if (group.groupid) {
	// 		await loadVehicle(group.groupid);
	// 	}
	// };
	const navigate = async (group) => {
		let rootGroupPath = '';
		let path = group.path;
		let pathArray = path.split('/').slice(1, -1); // Remove first and last empty elements
		let currentPath = rootGroupPath;
		let nav = [];
		let currentNode = { ...window.group }; // Start from the root group

		if((Object.keys(currentNode).length === 0)) {
			currentNode = myGroup.groupid === 0 ? myGroup.children?.[0] || {} : myGroup
		}
		nav.push(currentNode);

		// Traverse the group hierarchy
		for (let idx of pathArray) {
			currentPath += '/' + idx;
			let foundNode = currentNode.children?.find((child) => child.path === currentPath + '/');

			if (foundNode) {
				currentNode = foundNode;
				if (!('children' in currentNode)) currentNode.children = [];
				nav.push(currentNode);
			}
		}

		setGroups([...nav]);

		if (nav.length > 1) {
			dispatch(setTripReportGroupTree([...nav]));
		} else if (myGroup?.children?.length) {
			dispatch(setTripReportGroupTree([{ ...myGroup.children[0] }]));
		}
		setSelectedGroup(group);

		if (group.groupid) {
			await loadVehicle(group.groupid);
		}
	};

	return (
		<div className="TripReport">
			<div className="ControlPanel">
				<div className="UpControl">
					<div className="LeftControl">
						<div className="trip-group-tree">
							{/* {console.log(selectedGroup)} */}
							<GroupTree
								props={{ groups: groups, selectedGroup: selectedGroup }}
								navigate={navigate}
							/>
						</div>
					</div>
					<div className="RightControl">
						<MultiSelect
							data={vehicleList || []}
							displayKey={'vehicleno'}
							operationKey={'vehicleid'}
							selectedItem={selectedVehicle}
							loading={loadingVehicle}
							onSelect={(vehicles) => {
								setSelectedVehicle(vehicles);
								updatePreserveState('selectedVehicle', vehicles);
							}}
							paginate={(no) => setPageNo(no)}
							inBlock
						/>
						<DatePicker
							value={startTime}
							onChange={(date) => {
								updatePreserveState('starttime', date);

								setStartTime(date);
							}}
							showTime={false}
							disableToday={true}
							label="Start date"
						/>
						<DatePicker
							value={endTime}
							onChange={(date) => {
								setEndTime(date);
								updatePreserveState('endtime', date);
							}}
							showTime={false}
							disableToday={true}
							label="End date"
						/>
						<div
							className={'FetchButton ' + (isLoading || loadingVehicle ? 'disableButton' : '')}
							onClick={() => fetchTripReport()}
						>
							OK
						</div>
						<div className="ControlButton" onClick={() => setOpenDownload(true)}>
							<DownloadIcon style={{ cursor: 'pointer' }} />
						</div>
						{openDownload ? (
							<div className="downloadPopup">
								<span className="title">
									<span className="titleName">Download</span>
									<span className="closeBtn" onClick={() => setOpenDownload(false)}>
										x
									</span>
								</span>
								<div className="downloadButton">
									<span onClick={JSONToCSV}>download All</span>
									<span
										onClick={() => {
											downloadSummary();
										}}
									>
										Summary
									</span>
								</div>
							</div>
						) : null}
					</div>
				</div>
				{tripReport && !isLoading ? (
					<div className="DownControl">
						<div className="SearchContainer">
							<SearchBox onSearch={searchTripReport} />
						</div>

						<div className="ControlCenter">
							<span>Showing for &nbsp;</span>
							{dataForGroup.length > 0 &&
								dataForGroup.map((group, key) => {
									if (key < dataForGroup.length - 1) {
										return (
											<div style={{ display: 'flex' }}>
												<span>{` ${group.name}`}</span>
												<div className="hni-icon">
													<span className="fa fa-chevron-right"></span>
												</div>
											</div>
										);
									} else {
										return <span>{` ${group.name}`}</span>;
									}
								})}
						</div>

						<div className="ControlRight">
							<span>Vehicles:&nbsp; </span>
							{tripReport && (
								<span style={{ width: '4rem' }}>{`  ${tripReport.totalvehicles}`}</span>
							)}
						</div>
					</div>
				) : null}
			</div>
			{/* {tripReport ? (
				<div className="ReportType">
					<ul>
						<li
							className={reportType === 0 ? 'active' : ''}
							onClick={() => {
								setReportType(0);
								updatePreserveState('reportType', 0);
							}}
						>
							Trip
						</li>
						<li
							className={reportType === 1 ? 'active' : ''}
							onClick={() => {
								setReportType(1);
								updatePreserveState('reportType', 1);
							}}
						>
							Daily
						</li>
					</ul>
				</div>
			) : null} */}
			<div className="ReportsContainer">
				{isLoading ? (
					// <RadialProgress isLoading={true} />
					<div className="loader">
						LOADING<span></span>
					</div>
				) : !tripReport || tripReport?.history.length === 0 || isError ? (
					<EmptyState
						title={isError ? 'Something went wrong' : 'No Data'}
						description={
							isError
								? "Looks like we couldn't fetch data for given timerange"
								: 'Looks like we have no record for the selected date'
						}
					/>
				) : (
					renderLayout()
				)}
			</div>
		</div>
	);
}

export default TripReport;
